// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SigninSignup__wrapper--Ftl33{width:100vw}`, "",{"version":3,"sources":["webpack://./src/js/components/common/ui/SigninSignup.vue"],"names":[],"mappings":"AAEA,8BACE,WAAA","sourcesContent":["@use '@/scss/lib/base/variables' as *;\n\n.wrapper {\n  width: 100vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `SigninSignup__wrapper--Ftl33`
};
module.exports = ___CSS_LOADER_EXPORT___;
